import FetcherRepository from './FetcherRepository.js'

/**
 * @class
 * @implements FetcherRepository
 */
export default class HTTPFetcherRepository extends FetcherRepository {
  constructor({log, fetcher, localRepository, apiWebUrl}) {
    super()
    this._log = log
    this._fetcher = fetcher
    this._localRepository = localRepository
    this._apiWebUrl = apiWebUrl
  }

  /**
   * @return {Promise<String>}
   */
  getAuthenticationToken({userId, token}) {
    this._log('Retrieving authentication token')

    return this._fetcher
      .post(`${this._apiWebUrl}/authentication`, {userId, token})
      .then(({data: {authenticationToken}}) => {
        if (authenticationToken) {
          this._localRepository.setAuthenticationToken({
            authenticationToken,
            userId
          })

          return authenticationToken
        }
      })
      .catch(() => {
        token &&
          this._localRepository.removeAuthenticationToken({
            userId
          })
      })
  }
}
